var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBlue3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 625,
    viewBox: "0 0 80 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-73.9741 1.55505C-28.0933 33.0229 23.3054 62.4679 78.8937 89.2156V575.507C23.3054 590.117 -28.0933 606.076 -73.9741 623.271V1.55505Z",
    fill: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.4633 2.56652C-27.7868 33.8096 23.3053 63.0298 78.3827 89.5528V574.945C23.2032 589.443 -27.889 605.401 -73.4633 622.372V2.56652ZM-74.4851 0.543579V624.057C-28.1956 606.75 23.4075 590.679 79.4046 575.956V88.8785C23.4075 61.906 -28.1956 32.3486 -74.4851 0.543579Z",
    fill: "#00C8D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlue3);
export default __webpack_public_path__ + "static/media/LeftBlue3.5b8b314e138c0665bd50d995f8fb3ad8.svg";
export { ForwardRef as ReactComponent };